import moment from 'moment';

import genEnum from '../services/genEnum';
import genModel from '../services/genModel';
import { YesNoUnknown } from '../common/Models';

export const CreditCheckPurpose = genEnum(
  'CREDIT_APPLICATION',
  'CREDIT_CONTROL',
  'DEBT_COLLECTION',
  'KEY_PERSON',
  'OWN_APPROVAL',
  'LEASE_AGREEMENT',
  'WORK_RELATED_EVALUATION',
  'INFORMATION_FOR_AUTHORITY',
  'GUARANTEE_OR_PLEDGE',
  'AGREEMENT_DEFINITION'
);

export class BaseInformation extends genModel({
  date: { default: moment.utc(), type: 'moment' },
  issuer: { default: '', type: 'string' },
  provider: { default: '', type: 'string' },
  requester: { default: '', type: 'string' },
  purpose: { default: '', type: 'string' }
}) {}

export class TargetPerson extends genModel({
  ssn: { default: '', type: 'string' },
  provided_name: { default: '', type: 'string' },
  reported_name: { default: '', type: 'string' },
  user_id: { default: '', type: 'string', optional: true }
}) {}

export class Records extends genModel({
  count: { default: 0, type: 'number' },
  last: { default: moment.utc(), type: 'moment' },
  expires: { default: moment.utc(), type: 'moment' }
}) {}

export class Receipt extends genModel({
  receipt_id: { default: '', type: 'string' },
  raw_price: { default: 0, type: 'number' },
  currency: { default: 'EUR', type: 'string' },
  vat: { default: 0, type: 'number' },
  date: { default: moment.utc(), type: 'moment' },
  issuer: { default: '', type: 'string' },
  company_id: { default: '', type: 'string' }
}) {
  get price() { return this.raw_price / 100 }

  get vatFreePart() { return (this.raw_price / (1 + this.vat)) / 100 }

  get vatPart() { return ((this.raw_price * this.vat) / (1 + this.vat)) / 100 }
}

export class MinimalRecordDetails extends genModel({
  checked: { default: YesNoUnknown.UNKNOWN, type: 'enum', enum: YesNoUnknown },
  date: { default: moment.utc(), type: 'moment' },
  records: { default: 0, type: 'number' }
}) {}

export class CreditCheckReport extends genModel({
  base_information: { default: new BaseInformation(), type: 'model', model: BaseInformation },
  target_person: { default: new TargetPerson(), type: 'model', model: TargetPerson },
  records: { default: Records.empty, type: 'model', model: Records },
  receipt: { default: Receipt.empty, type: 'model', model: Receipt }
}) {
  get minimalRecordDetails() {
    /* eslint-disable no-underscore-dangle, no-return-assign */
    return (
      this._minimalRecordDetails ||
      (this._minimalRecordDetails = (
        this.isEmpty ?
          MinimalRecordDetails.empty :
          new MinimalRecordDetails({
            checked: YesNoUnknown.YES,
            date: this.receipt.date,
            records: this.records.count
          })
      ))
    );
    /* eslint-enable no-underscore-dangle, no-return-assign */
  }
}
